import React from 'react';
export default function GalleryImage(_ref) {
  var style = _ref.style,
      onLoad = _ref.onLoad,
      children = _ref.children;
  return React.createElement("div", {
    className: "gallery-image-drop-wrapper",
    style: style,
    onLoad: onLoad
  }, children);
}